import { useEffect } from 'react';
import { navigate } from "@reach/router"

const TermsOfUsePage = () => {
  useEffect(() => {
    navigate('/terms');
  }, []);
  return null;
};

export default TermsOfUsePage;